import React from 'react';
import type ProjectSettingsServiceDeskFeedbackSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-feedback-settings/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const NEXTGEN_SETTINGS = 'project/service-desk/settings/index';
export const CLASSIC_SETTINGS = 'project/service-desk/settings';

export const LazyProjectSettingsServiceDeskFeedbackSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskFeedbackSettingsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-feedback-settings", jiraSpaEntry: "async-project-settings-service-desk-feedback-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-feedback-settings'
		),
);

const AsyncProjectSettingsServiceDeskFeedbackSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskFeedbackSettings}
		pageId="project-settings-feedback-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskFeedbackSettings;
